import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout route for the whole `/bookings/*` subtree (found live, in the
 * Task-13 browser smoke test — the fix round the controller asked for).
 *
 * TanStack Router's flat file-route convention makes any `bookings.tsx`
 * alongside `bookings.$reference.tsx` / `bookings.calendar.tsx` /
 * `bookings.arrivals-print.tsx` / `bookings.$reference.print.tsx` their
 * PARENT layout route (the generated `BookingsRouteWithChildren` in
 * `routeTree.business.gen.ts`) — every `/bookings/*` URL renders THIS
 * component first, and a sibling's content only appears through this
 * component's own `<Outlet/>`. The list UI previously lived directly in
 * this file (pre-fix), which meant visiting `/bookings/calendar` or
 * `/bookings/$reference` silently rendered the bookings LIST instead (no
 * console error — the router matched correctly and fired the list's own
 * data query, so this was easy to miss without an actual browser check).
 * The list UI itself now lives in `bookings.index.tsx`
 * (`createFileRoute('/bookings/')`), the exact-`/bookings` index route
 * that fills this Outlet when nothing more specific matches.
 *
 * `rates.tsx`+`rates.$listingId.tsx`, `listings.tsx`+`listings.$id.edit.tsx`
 * and `statements.tsx`+`statements.$period(.print).tsx` have the identical
 * dot-nesting shape and are still content-less M2 placeholders — same bug
 * lying in wait once a later task fills them in with real content. Flagged
 * in this task's report; not fixed here (nothing to fix yet, and it isn't
 * this task's file to touch).
 */
export const Route = createFileRoute('/bookings')({
  component: BookingsLayout,
});

function BookingsLayout() {
  return <Outlet />;
}
